import apiService from '../../../share/util/api/service';
import { executePolling } from '../../../share/util/api/polling';
import { VEHICLE_INIT } from './constants';

/**
 * カスタマイズ: 初期化通信ポーリング実行
 * @param {object} root 呼び出し元
 * @param {string} systemName システム名
 * @param {object} bodyParam POST時に設定するリクエストBody
 * @param {boolean} bodyParam.isUseCache キャッシュ利用要否
 * @param {string[]?} bodyParam.system_name システム名リスト(全カスタマイズの時のみ使用) 
 * @returns {Promise<object?>} 実行結果
 */
export const initCustomize = async (root, systemName, bodyParam) =>
  await executePolling(
    root,
    // POST API 呼び出しのコールバック
    async () => await apiService.postCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/initialize`,
      bodyParam
    ),
    // GET API 呼び出しのコールバック
    async (postApiResponse) => await apiService.getCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/customize/requests/${postApiResponse.data.request_id}`
    ),
    // エラー発生のコールバック
    (errorType) => { errorType; root.showUnexpectedError(VEHICLE_INIT); },
    // POST API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // GET API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_INIT); },
    // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_INIT); },
  );

export default {
  VEHICLE_INIT,
  initCustomize,
};